import { Typography } from '@lingoda/ui';

export const FAQBlock = () => (
    <Typography variant="body2" htmlColor="text.secondary">
        Please see our FAQ for details about plans and promotions.
    </Typography>
);
